// Global Utils
import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
// @ts-ignore
import { selectCurrentOrganizationId } from 'services/currentOrganizationId/selectors';
import { selectSprayEventTypeIsWeed } from 'services/sprayEventType/selectors';
import { selectStartDate } from './selectors';

const selectLoadSprayedEntitiesParams = createDeepEqualSelector(
    selectStartDate,
    selectCurrentOrganizationId,
    selectSprayEventTypeIsWeed,
    (date, organizationId, isWeedSpray) => ({
        organizationId,
        filter: {
            fields: ['id'],
            require: {
                'sprayEvents.event.startDate': date,
                'sprayEvents.event.deletedAt': { $exists: false },
                'sprayEvents.isWeedSpray': isWeedSpray
            }
        }
    })
);

export { selectLoadSprayedEntitiesParams };
